import { combineReducers } from 'redux'

// import filtroAplicados from "./filtroAplicados"

import filtroAplicados from './filtroAplicados'
import resultados from './detalhesMetasEducacaoOrgao'

export default combineReducers({ filtroAplicados, resultados })
